import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { UtilService } from '@shared/services/util.service';
import { Subject, takeUntil } from 'rxjs';
import { MatSidenavModule } from '@angular/material/sidenav';
import { AdminToolbarComponent } from '../admin-toolbar/admin-toolbar.component';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [
    RouterModule,
    MatSidenavModule,
    AdminToolbarComponent
  ],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss'
})
export class AdminLayoutComponent {
  title = 'polizas';
  opened = true;
  private destroy$ = new Subject<void>();

  constructor(private utilSvc: UtilService) {}

  ngOnInit(): void {
    this.utilSvc.sidenavOpen$.pipe(takeUntil(this.destroy$)).subscribe((sidenav) => {
      this.opened = sidenav;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
